import { Box, Skeleton } from '@mui/material';
import theme from '../../../theme';

const CallsDataSkeleton = () => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        height: 'calc(100vh - 280px)',
        minHeight: 400,
        width: '100%',
        border: `1px solid ${theme.palette.lightGray.main}`,
        borderRadius: '12px',
        p: 2,
      }}
    >
      {/* Toolbar */}
      <Box sx={{ mb: 2, display: 'flex', gap: 1 }}>
        <Skeleton
          variant="rectangular"
          width={100}
          height={40}
          sx={{ borderRadius: '8px' }}
        />
        <Skeleton
          variant="rectangular"
          width={100}
          height={40}
          sx={{ borderRadius: '8px' }}
        />
        <Skeleton
          variant="rectangular"
          width={100}
          height={40}
          sx={{ borderRadius: '8px' }}
        />
        <Box sx={{ flexGrow: 1 }} />
        <Skeleton
          variant="rectangular"
          width={200}
          height={40}
          sx={{ borderRadius: '8px' }}
        />
      </Box>

      {/* Column Headers */}
      <Box sx={{ display: 'flex', mb: 2, gap: 1 }}>
        <Skeleton
          variant="rectangular"
          width={130}
          height={52}
          sx={{ borderRadius: '8px' }}
        />
        <Skeleton
          variant="rectangular"
          width={130}
          height={52}
          sx={{ borderRadius: '8px' }}
        />
        <Skeleton
          variant="rectangular"
          width={130}
          height={52}
          sx={{ borderRadius: '8px' }}
        />
        <Skeleton
          variant="rectangular"
          width={180}
          height={52}
          sx={{ borderRadius: '8px' }}
        />
        <Skeleton
          variant="rectangular"
          width={180}
          height={52}
          sx={{ borderRadius: '8px' }}
        />
        <Skeleton
          variant="rectangular"
          width={140}
          height={52}
          sx={{ borderRadius: '8px' }}
        />
        <Skeleton
          variant="rectangular"
          width={220}
          height={52}
          sx={{ borderRadius: '8px' }}
        />
        <Skeleton
          variant="rectangular"
          width={220}
          height={52}
          sx={{ borderRadius: '8px' }}
        />
        <Skeleton
          variant="rectangular"
          width={130}
          height={52}
          sx={{ borderRadius: '8px' }}
        />
      </Box>

      {/* Rows as single rectangles */}
      {[...Array(5)].map((_, index) => (
        <Box key={index} sx={{ mb: 1 }}>
          <Skeleton
            variant="rectangular"
            height={52}
            sx={{ borderRadius: '8px' }}
          />
        </Box>
      ))}

      {/* Pagination */}
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
        <Skeleton
          variant="rectangular"
          width={200}
          height={40}
          sx={{ borderRadius: '8px' }}
        />
        <Skeleton
          variant="rectangular"
          width={120}
          height={40}
          sx={{ borderRadius: '8px' }}
        />
      </Box>
    </Box>
  );
};

export default CallsDataSkeleton;
